import { Prisma } from '@prisma/client';
import { OrganizationInclude } from '../includes/Organization';
var IncludeOrganization = Prisma.validator()({
    include: OrganizationInclude,
});
export var ExportType;
(function (ExportType) {
    ExportType["ORGANIZATION"] = "organization";
    ExportType["LOGS"] = "logs";
    ExportType["CALCULATIONS"] = "calculations";
})(ExportType || (ExportType = {}));
//# sourceMappingURL=Organization.js.map